import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { SessionsListResponse } from "@/api/types";
import { useCurrentUser } from "./use-current-user";

export function useActiveSessions() {
  const { data: user } = useCurrentUser();

  return useQuery({
    queryKey: ["sessions"],
    queryFn: ({ signal }) => api.get("sessions", { signal }).json<SessionsListResponse>(),
    enabled: !!user,
    staleTime: 30_000,
  });
}
